/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { metricsGetApiV3MetricsIngressBandwidth } from "../../funcs/metricsGetApiV3MetricsIngressBandwidth.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3MetricsIngressBandwidthRequest$inboundSchema
    .optional(),
};

export const tool$metricsGetApiV3MetricsIngressBandwidth: ToolDefinition<
  typeof args
> = {
  name: "metrics-get-api-v3-metrics-ingress-bandwidth",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await metricsGetApiV3MetricsIngressBandwidth(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
